module.exports = __webpack_public_path__ + "img/buddies(LQ).aa146ca3.png";